import {Injectable} from '@angular/core';
import {AbstractWidgetService} from '../../services/abstract-widget.service';
import {DocumentEditorActionsType, DocumentInfo, TemplateActionArgs, UiWidget} from '@pt/pt-models';
import {WidgetUtils} from '../widget.utils';
import {WidgetContactChooserValueV0Dto} from './v0/models/widget-contact-chooser-value-v0.dto';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {GetChapterResponse} from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import {ChapterSelector} from "it/primatoo/openapi/api/org/schemas/common/docs/ChapterSelector";

@Injectable({
  providedIn: 'root'
})
export class WidgetContactChooserService extends AbstractWidgetService {

  constructor(public store: Store, public translateService: TranslateService) {
    super(store, translateService);
  }

  /**
   * TRIGGER
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  execTrigger(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    this.unsupportedTrigger(widget);
    return null;
  }


  /**
   * INITIALIZATION
   * @param context
   * @param widgets
   * @param widgetId
   * @param action
   * @param args
   * @param queryResponse
   */
  initialization(context: GetChapterResponse, widgets: UiWidget[], widgetId: number, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any): UiWidget | null {
    const widget = widgets?.find(w => w.internalId === widgetId);
    if (widget?.version !== null && widget?.version !== undefined) {
      switch (widget.version) {
        case 0:
          return this.initializationV0(context, widgets, widget, action, args, queryResponse);
        default:
          this.invalidWidgetVersion(widget);
          return null;
      }
    }
    return null;
  }

  private initializationV0(context: GetChapterResponse, widgets: UiWidget[], widget: UiWidget, action: DocumentEditorActionsType, args: TemplateActionArgs, queryResponse?: any) {
    let value: WidgetContactChooserValueV0Dto[];
    const currentWidget: UiWidget = JSON.parse(JSON.stringify(widget));
    switch (action) {
      case DocumentEditorActionsType.INITIALIZATION:
        this.validWidgetAction(widget, action);
        value = WidgetUtils.mappingQueryResponse(queryResponse, args?.query?.mapping) as WidgetContactChooserValueV0Dto[];
        currentWidget.value = value;
        return currentWidget;

      default:
        this.invalidWidgetAction(widget, action);
    }
    return null;
  }
}
